import type { ApiErrorProblem } from "../types";

type ApiErrorLike = {
  response?: {
    status?: number;
    data?: Partial<ApiErrorProblem> | null;
  };
};

const REGIONAL_ERROR_CODES_WITH_BACKEND_DETAIL = [
  "REGIONAL_ALREADY_EXISTS",
  "VALIDATION_ERROR",
  "ENTITY_HAS_DEPENDENCIES",
];

export const REGIONAL_NOT_FOUND_MESSAGE = "A regional selecionada não existe mais. Atualize a lista e selecione outra.";

export const getApiErrorCode = (error: unknown): string | null => {
  const code = (error as ApiErrorLike)?.response?.data?.code;
  return typeof code === "string" && code.length > 0 ? code : null;
};

export const getApiErrorDetail = (error: unknown): string | null => {
  const detail = (error as ApiErrorLike)?.response?.data?.detail;
  return typeof detail === "string" && detail.trim().length > 0 ? detail : null;
};

export const getApiErrorStatus = (error: unknown): number | null => (error as ApiErrorLike)?.response?.status ?? null;

export const getRegionalErrorMessage = (error: unknown, fallbackMessage: string): string => {
  const code = getApiErrorCode(error);
  const detail = getApiErrorDetail(error);

  if (code && detail && REGIONAL_ERROR_CODES_WITH_BACKEND_DETAIL.includes(code)) return detail;

  return fallbackMessage;
};

export const getTransactionSaveErrorMessage = (error: unknown, fallbackMessage: string): string =>
  getApiErrorCode(error) === "REGIONAL_NOT_FOUND" ? REGIONAL_NOT_FOUND_MESSAGE : fallbackMessage;
